import { Brain } from 'lucide-react';
import { AGENT_MODULE_BY_KEY } from '../../ai-agent/config/agentModuleRegistry';

function isConfigSubsection(sub) {
  return (
    sub.nameKey?.endsWith('.configuration') ||
    sub.nameKey?.endsWith('.settings') ||
    sub.nameKey?.endsWith('.config') ||
    sub.href?.endsWith('/config') ||
    sub.href?.endsWith('/settings')
  );
}

function isAgentSubsection(sub, agentDef) {
  return (
    sub.href === agentDef.agentPath ||
    sub.nameKey?.endsWith('.subsections.agent')
  );
}

function agentNameKey(moduleKey) {
  return `modules.${moduleKey.toLowerCase()}.subsections.agent`;
}

/**
 * Insert "Agent {Module}" subsection before Configuration in each licensed module.
 */
export function enrichModuleStructureWithAgents(modules) {
  return modules.map((module) => {
    const agentDef = AGENT_MODULE_BY_KEY[module.key];
    if (!agentDef) return module;

    const agentKey = agentNameKey(module.key);
    const hasAgent = module.subsections.some((sub) => isAgentSubsection(sub, agentDef));
    if (hasAgent) {
      return {
        ...module,
        subsections: module.subsections.map((sub) =>
          isAgentSubsection(sub, agentDef)
            ? {
                ...sub,
                name: agentKey,
                nameKey: agentKey,
                href: agentDef.agentPath,
                icon: Brain,
              }
            : sub,
        ),
      };
    }

    const subsections = [...module.subsections];
    const configIdx = subsections.findIndex(isConfigSubsection);
    const insertAt = configIdx >= 0 ? configIdx : subsections.length;

    subsections.splice(insertAt, 0, {
      name: agentKey,
      nameKey: agentKey,
      href: agentDef.agentPath,
      icon: Brain,
    });

    return { ...module, subsections };
  });
}
